import { FC } from "react";
import { useLingui } from "@lingui/react";
import { ShopType, SingleProduct } from "src/types/graphql.d";
import { getI18nRoute } from "src/utils/i18nRoutes";
import { Locale } from "lib/Intl";
import { Breadcrumbs, BreadcrumbsItem } from "src/molecules/Breadcrumbs";
import { msg } from "@lingui/macro";
import { shopTypeTranslation } from "src/translations/shopTypeTranslation";

interface Props {
  product?: SingleProduct;
  genderId: string;
  locale: Locale;
}

const ProductBreadcrumbs: FC<Props> = ({ product, genderId, locale }) => {
  const kidsSubGender =
    product && (product?.kids_sub_categories?.[0]?.slug as string);
  const gender = kidsSubGender ? ShopType.Kids : genderId;
  const productCategorySlugHref = kidsSubGender
    ? getI18nRoute({ route: `/${genderId}/${kidsSubGender}`, locale })
    : `${getI18nRoute({
        route: `/${gender.toLowerCase()}`,
        locale,
      })}/categories`;
  const { _ } = useLingui();

  const items: BreadcrumbsItem[] = [
    {
      name: _(msg`Home`),
      href: getI18nRoute({ route: `/${genderId}`, locale }),
    },
    {
      name: _(shopTypeTranslation[gender]),
      href: productCategorySlugHref,
    },
    ...(product
      ? [
          {
            name: product.brand.name,
            href: "/[slug]/[brandSlug]/[genderId]",
            as: `${getI18nRoute({ route: `/brands`, locale })}/${
              product.brand.slug
            }${getI18nRoute({ route: `/${genderId}`, locale })}`,
          },
          {
            name: product.name,
          },
        ]
      : []),
  ];

  return <Breadcrumbs items={items} />;
};

export default ProductBreadcrumbs;
